import React, { useEffect, useRef, useState } from 'react'
import editIcon from '../../../assets/images/Edit.svg'
import permissions from 'client/utils/Permissions';
import deleteIcon from '../../../assets/images/Delete 2 New.svg'
import dragDropIcon from '../../../assets/images/Drag & Drop.svg'
import { Tooltip, EventHandler } from 'client/CommonComponents';
import { CONSTANTS } from 'client/utils/constants';

const DraggableReportList = (props: any) => {
    const {
        listItems,
        getlinkIcon,
        isAuthorized,
        setUserAction,
        deleteReportLink,
        onClickAddEditCategory,
        categoryId,
        handleDownloadReport
    } = props

    const draggedItem = useRef<any>('');
    const [list, setList] = useState<any>([]);
    const [isDownloading, setIsDownloading] = useState<string>('');
    
    useEffect(() => {
        if (listItems?.length) {
            let tempList = listItems?.map((link: any) => ({...link, categoryId: categoryId}))
            setList(tempList)
        }
    }, [listItems])

    const onDragStart = (e: any, categoryReportId: number) => {
        draggedItem.current = list?.find((link: any) => link?.categoryReportId === categoryReportId)
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/html", e.target.parentNode);
        e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
    };

    const onDragOver = (e: any, index: number, categoryReportId: number) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = "move";
        const draggedOverItem = list?.find((link: any) => link?.categoryReportId === categoryReportId);

        // if the item is dragged over itself, ignore
        if (draggedItem?.current?.categoryReportId === draggedOverItem?.categoryReportId || draggedItem?.current?.categoryId !== draggedOverItem?.categoryId) {
            return;
        }

        // filter out the currently dragged item
        let items = list.filter((item: any) => item?.categoryReportId !== draggedItem?.current?.categoryReportId);

        // add the dragged item after the dragged over item
        items.splice(index, 0, draggedItem?.current);

        setList(items);
    };

    const onDragEnd = (e:any) => {
        draggedItem.current = null;
    };

    return (
        <div className='DnD_container'>
            {list?.map((item: any, idx: any) => (
                <li key={item?.categoryReportId} onDragOver={(e: any) => onDragOver(e, idx, item?.categoryReportId)}>
                    <div
                        className="drag"
                        draggable
                        onDragStart={(e: any) => onDragStart(e, item?.categoryReportId)}
                        onDragEnd={onDragEnd}
                    >
                        <img
                            src={dragDropIcon}
                            alt='Drag and Drop'
                            className='me-2 dragDropIcon'
                            title='Drag and Drop'
                        />
                        <img src={getlinkIcon(item?.reportIconUrl)} alt="Report Icon" className='report-icon me-2' />
                        {item?.categoryReportName === 'E1 Upload Template' ?
                            <Tooltip content={item?.categoryReportName} className="tooltip_contents" data-attribute="DraggableReportList_Default_Tooltip">
                                <a 
                                    href="#" 
                                    onClick={(e) => { 
                                        handleDownloadReport(e); 
                                    }}
                                >
                                    {item?.categoryReportName}
                                </a>
                            </Tooltip>
                            : item?.isExternalReport ?
                                <Tooltip content={item?.categoryReportName} className="tooltip_contents" data-attribute="DraggableReportList_Default_Tooltip_2">
                                    <a href={item?.categoryReportUrl} target="_blank" rel="noreferrer noopener external">
                                        {item?.categoryReportName}
                                    </a>
                                </Tooltip>
                            :
                            <Tooltip content={item?.categoryReportName} data-attribute="DraggableReportList_Default_Tooltip_3"><a href={item?.categoryReportUrl}>{item?.categoryReportName}</a></Tooltip>
                        }
                        <span className='action-icon'>
                            {isAuthorized(permissions.CreateUpdateReports) &&
                                <img
                                    id={`link_${item?.categoryReportId}`}
                                    src={editIcon}
                                    alt='Edit'
                                    className='me-2'
                                    title='Edit Link'
                                    onClick={(e: any) => { onClickAddEditCategory(e, 'link_' + item?.categoryReportId, categoryId, item); setUserAction('update') }}
                                />
                            }
                            {isAuthorized(permissions.DeleteReport) &&
                             (item?.categoryReportName !== CONSTANTS.REPORTS.BARCODE_REPLACEMENT_REPORT && item?.categoryReportName !== CONSTANTS.REPORTS.E1_UPLOAD_TEMPLATE) && (
                                <EventHandler onEvent={(e: any) => { deleteReportLink(item?.categoryReportId, item?.categoryReportName); setUserAction('delete'); }} data-attribute="DraggableReportList_Default_EventHandler">
                                <img
                                    src={deleteIcon}
                                    alt="Delete"
                                    title="Delete"
                                />
                                </EventHandler>
                            )}
                        </span>
                    </div>
                </li>
            ))}
        </div>

    )
}

export default DraggableReportList